import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { TableLayout } from "../../layout/TableLayout";
import { selectOpportunity } from "../../../store/opportunity/opportunitySlice";
import { deleteOpportunity } from "../../helpers/opportunity";
import { columnInvestor, columnsAdmin } from "../../helpers/columnsOpportunity";
import { useNavigate } from "react-router-dom";
import { Hidden } from "@mui/material";
import { EditOportunityWrapper } from "./EditOportunityWrapper";

export const OpportunitiesTable = ({ rows, setReloadData, vehiclesList }) => {
  const { t } = useTranslation("global");
  const dispatch = useDispatch();
  const { userToAction } = useSelector((state) => state.partner);
  const [openEdit, setOpenEdit] = useState(false);
  const { role } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const onReserveClick = (e) => {
    navigate(`/reservation`);
    dispatch(selectOpportunity(e.row));
  };

  const onEditClick = (e) => {
    dispatch(
      selectOpportunity({
        ...e.row,
        clubFilter: JSON.parse(e?.row?.clubFilter),
      })
    );
    setOpenEdit(true);
  };

  const onDeleteClick = async (e) => {
    await deleteOpportunity(
      e,
      t("delete.successMsg"),
      t("delete.errorMsg"),
      t("delete.cancelButton"),
      t("delete.confirmButton"),
      t("delete.deleteConfirm")
    );
    setReloadData((prevState) => !prevState);
  };

  const onViewClick = async (e) => {
    dispatch(selectOpportunity(e.row));
    navigate(
      `/opportunityViews?opportunity=${e.row.id}&name=${e.row.startup}&startup=${e.row.startupId}`
    );
  };

  let columns;
  if (role === "Admin") {
    columns = columnsAdmin(t, onDeleteClick, onEditClick, onViewClick);
  } else {
    columns = columnInvestor(t, onReserveClick);
  }

  return role === "Admin" ? (
    <>
      <TableLayout
        rows={rows}
        columns={columns}
        title="opportunities"
        name={role}
      />
      {userToAction.startup !== "" && openEdit && (
        <EditOportunityWrapper
          setHidden={setOpenEdit}
          setReloadData={setReloadData}
          vehiclesList={vehiclesList}
        />
      )}
    </>
  ) : (
    <Hidden mdDown>
      <TableLayout
        rows={rows}
        columns={columns}
        title="opportunities"
        name={role}
      />
    </Hidden>
  );
};
